<template>
  <div class="content">
    <div class="login-con">
      <Card :bordered="false">
        <p slot="title">
          <Icon type="log-in"></Icon>
          欢迎登录
        </p>
        <div class="form-con">
          <Form ref="loginForm"
                :model="form"
                :rules="rules">
            <FormItem prop="userName">
              <Input v-model="form.userName"
                     placeholder="请输入用户名"
                     :maxlength="20"
                     style="width: 100%">
              <span slot="prepend">
                <Icon :size="16"
                      type="person"></Icon>
              </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input type="password"
                     v-model="form.password"
                     placeholder="请输入密码"
                     :maxlength="20"
                     style="width: 100%"
                     @keyup.enter.native="handleSubmit">
              <span slot="prepend">
                <Icon :size="14"
                      type="locked"></Icon>
              </span>
              </Input>
            </FormItem>
            <FormItem>
              <Button @click="handleSubmit"
                      type="primary"
                      long>登录</Button>
            </FormItem>
          </Form>
          <!--<p class="login-tip">输入任意用户名和密码即可</p>-->
        </div>
      </Card>
    </div>

  </div>
</template>

<script>
import crypto from "crypto";
export default {
  name: 'Login',
  data () {
    return {
      form: {
        userName: '',
        password: ''
      },
      rules: {
        userName: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { message: '用户名不少于4位', trigger: 'blur', min: 1 }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { message: '密码不少于6位', trigger: 'blur', min: 6 }
        ]
      },
    };
  },

  methods: {
    handleSubmit: async function () {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          if (this.form.userName && this.form.password) {
            let md5 = crypto.createHash('md5');
            md5.update(this.form.password);
            let pwd = md5.digest("hex");
            this.$Spin.show();

            const result = await this.$http.get(`/login/${this.form.userName}/${pwd.toLowerCase()}`, {});
            console.log(1234564869864);
            console.log(result.data);
            this.$store.commit("changeRole", result.data.role);
            this.$store.commit("changeName", result.data.adminName);
            this.$store.commit("changeShopId",result.data.shopId);
            this.$store.commit("changeLimitNum",result.data.limitNum);
            this.$store.commit("changeLimitMoneyNum",result.data.limitMoneyNum);
            this.$store.commit("changeSensitive_Limit", result.data.sensitive_Limit);
            this.$store.commit("changeRemove_Limit",result.data.remove_Limit);
            this.$store.commit("changeNew_Limit",result.data.new_Limit);
            this.$store.commit("changeNew_Money_Limit",result.data.new_Money_Limit);
            if(result.data.cinemaId){
              this.$store.commit("changeCinemaId",result.data.cinemaId);
            }else{
              this.$store.commit("changeCinemaId",0);
            }
            if(result.data.merId){
              this.$store.commit("changeMerId",result.data.merId);
            }else{
              this.$store.commit("changeMerId",0);
            }
            if(result.data.bankId){
              this.$store.commit("changeBankId",result.data.bankId);
            }else{
              this.$store.commit("changeBankId",0);
            }
            if(result.data.shopMerId){
              this.$store.commit("changeShopMerId",result.data.shopMerId);
            }else{
              this.$store.commit("changeShopMerId",0);
            }
            if(result.data.showMerId){
              this.$store.commit("changeShowMerId",result.data.showMerId);
            }else{
              this.$store.commit("changeShowMerId",0);
            }
            if(result.data.adminUserId){
              this.$store.commit("changeAdminUserId",result.data.adminUserId);
            }else{
              this.$store.commit("changeAdminUserId",0);
            }
            if(result.data.portType){
              this.$store.commit("changePortType",result.data.portType);
            }else{
              this.$store.commit("changePortType",null);
            }
            if(result.data.withId){
              this.$store.commit("changeWithId",result.data.withId);
            }else{
              this.$store.commit("changeWithId",0);
            }
            console.log(result);
            this.$Spin.hide();
            if (result.meta.success) {
              let token = result.data.token;
              console.log(4546545);
              console.log(token);
              window.localStorage.setItem('token', token);
              if(result.data.role=='admin'|| result.data.role=='staff'){
                if(result.data.adminName == '奇铺'){
                  this.$router.push({ name: 'qpEntityOrder' })
                }else{
                  this.$router.push({ name: 'Home' })
                }
              }else if(result.data.role == 'merchant'){
                this.$router.push({ name: 'merTicket' })
              }else if(result.data.role == 'bank'){
                this.$router.push({ name: 'couponCode' })
              }else if(result.data.role == 'shopMer'){
                this.$router.push({ name: 'shopTicket' })
              }else if(result.data.role == 'showMer'){
                this.$router.push({ name: 'showOrder' })
              }else if(result.data.role == 'theater'){
                this.$router.push({ name: 'pwtOrderTheater' })
              }else if(result.data.role == 'with'){
                this.$router.push({ name: 'generalTicketOrder' })
              }else {
                this.$router.push({ name: 'Verification' })
              }
            }
            else {
              this.$Message.error('账号或密码错误');
            }
          }
          else {
            this.$Message.error('登录失败，请重试');
          }
        }
      });
    }
  },
}
</script>

<style scoped="">
page {
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  background-image: url("https://file.iviewui.com/iview-admin/login_bg.jpg");
  background-size: cover;
  background-position: center;
}

.login-con {
  position: absolute;
  right: 160px;
  top: 50%;
  transform: translateY(-60%);
  width: 300px;
}

.form-con {
  padding: 10px 0 0;
}

.login-tip {
  font-size: 10px;
  text-align: center;
  color: #c3c3c3;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue